import { PropsWithChildren, useEffect } from 'react'

import { useUI } from '@/Shared/ui/navigation'

interface ProtectedWrapperProps {
  title?: string
  description?: string
}

export const ProtectedWrapper = ({
  title,
  description,
  children,
}: PropsWithChildren<ProtectedWrapperProps>): JSX.Element => {
  const { registerNavigationModal, unregisterNavigationModal } = useUI()

  useEffect(() => {
    registerNavigationModal({
      title: title,
      description: description,
    })

    return () => {
      unregisterNavigationModal()
    }
  }, [])

  return <>{children}</>
}
